import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';
import { PermissionsContext } from '../../context/permissionsContext.js';

/**
 * Protege la ruta por permiso. Si el usuario no tiene el permiso (modulo.accion),
 * redirige a /gestion/dashboard. Si no está autenticado, redirige a /.
 * Uso: <PermissionRoute module="usuarios" action="ver"><GestionUsuarios /></PermissionRoute>
 */
const PermissionRoute = ({ children, module: modulo, action = 'ver' }) => {
  const { isAuthenticated, user } = useContext(LoginContext);
  const permCtx = useContext(PermissionsContext);
  const hasPermission = permCtx?.hasPermission ?? (() => false);
  const loading = permCtx?.loading ?? false;

  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  if (!permCtx && user?.usu_tipousuario === 1) {
    return children;
  }

  if (loading && user?.usu_tipousuario === 1) {
    return children;
  }

  if (loading) {
    return null;
  }

  if (!hasPermission(modulo, action)) {
    const firstPath = permCtx?.getFirstGestionPath?.();
    return <Navigate to={firstPath || '/gestion/dashboard'} replace />;
  }

  return children;
};

export default PermissionRoute;
